import { ViewColumn } from "@mui/icons-material";
import { Badge } from "@mui/material";

import styles from "./CharColumnsButton.module.css";

export const CharColumnsButton = ({ checkedColumnsCount, showColumnsDialog, disabled }) => {
	return (
		<Badge
			color="primary"
			overlap="rectangular"
			badgeContent={disabled ? 0 : checkedColumnsCount}
			anchorOrigin={{
				vertical: "top",
				horizontal: "left",
			}}
			sx={{
				"& .MuiBadge-standard": {
					padding: "0px 3px",
					minWidth: "10px",
					height: "10px",
					top: "25%",
					left: "2%",
					fontWeight: 400,
					fontSize: "6px",
				},
			}}
		>
			<button disabled={disabled} className={styles.button} onClick={() => showColumnsDialog()}>
				<ViewColumn />
				Столбцы характеристик
			</button>
		</Badge>
	);
};
